export default "__VITE_ASSET__BHsrGrCV__"